import { Chip } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';
import { DateSeparatorProps } from 'stream-chat-react';

import { useMessagingTheme } from 'src/features/messages/messagingThemeContext';
import DateUtils from 'src/utils/DateUtils';

const DATE_FORMAT = 'dddd[,] MMM DD';
export const CustomDateSeparator: React.FC<DateSeparatorProps> = React.memo(
  ({ date, unread }) => {
    const { isSidebarTheme } = useMessagingTheme();
    const when = React.useMemo(
      () =>
        DateUtils.humanizeDate(date.toISOString(), {
          sameDay: DATE_FORMAT,
          nextDay: DATE_FORMAT,
          nextWeek: DATE_FORMAT,
          lastDay: DATE_FORMAT,
          lastWeek: DATE_FORMAT,
        }),
      [date],
    );
    return (
      <div className="sticky top-0 z-10 flex justify-center my-3">
        <Chip
          label={unread ? `New - ${when}` : when}
          variant="outlined"
          className={clsx(
            isSidebarTheme && 'bg-gray-100 border-non-hover-border',
          )}
        />
      </div>
    );
  },
);
